import { addNewDomainAsync, removeDomainAsync } from './../actions';
import { DomainsActions } from './../types';
import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';
import { DomainsState } from '..';
import { fetchDomainsListAsync } from '../actions';
import fetchDomainsReducer from './fetchDomainsReducer';
import addNewDomainReducer from './addNewDomainReducer';
import removeDomainReducer from './removeDomainReducer';

const defaultAsyncState = {
  isError: false,
  isPending: false
};

export const initialDomainsState: DomainsState = {
  list: null,
  fetchList: defaultAsyncState,
  removeDomain: {
    ...defaultAsyncState,
    params: {
      domain: ''
    }
  },
  addNewDomain: {
    ...defaultAsyncState,
    params: {
      domain: ''
    }
  }
};

const domainsReducer: Reducer<DomainsState, DomainsActions> = (state = initialDomainsState, action) => {
  switch (action.type) {
    case getType(fetchDomainsListAsync.request):
    case getType(fetchDomainsListAsync.success):
    case getType(fetchDomainsListAsync.failure):
      return fetchDomainsReducer(state, action);

    case getType(addNewDomainAsync.request):
    case getType(addNewDomainAsync.success):
    case getType(addNewDomainAsync.failure):
      return addNewDomainReducer(state, action);

    case getType(removeDomainAsync.request):
    case getType(removeDomainAsync.success):
    case getType(removeDomainAsync.failure):
      return removeDomainReducer(state, action);

    default:
      return state;
  }
};

export default domainsReducer;
